import { fetchWebPage } from "../../api/webpage";
import { CmsDocumentPage } from "./CmsDocumentPage";

export const WebPage = () => (
  <CmsDocumentPage kind="page" fetchDocument={fetchWebPage} />
);

export default WebPage;
